module.exports = __webpack_public_path__ + "img/garry-smc.52e5821c.jpg";